/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const schemeSummarySchema = z.object({
  id: z.int(),
  membershipSynced: z.boolean(),
  name: z.string(),
  synced: z.boolean(),
  type: z.enum(['HOLIDAY', 'WORKLOAD']),
});
